import apiClient from '../lib/apiClient';

const authService = {
  login(credentials) {
    return apiClient.request('/auth/login', {
      method: 'POST',
      body: JSON.stringify(credentials)
    });
  },
  signup(payload) {
    return apiClient.request('/auth/register', {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  },
  googleAuth(redirectUri) {
    return apiClient.request(`/auth/google?redirect_uri=${encodeURIComponent(redirectUri)}`);
  },
  googleCallback(payload) {
    return apiClient.request('/auth/google/callback', {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  }
};

export default authService;
